import firebase from "firebase";
// eslint-disable-next-line
import firestore from "firebase/firestore";

var config = {
    apiKey: "AIzaSyDJfHpQ6_4ULsHbVMsSGJn1hg00NCn08vI",
    authDomain: "apply.obama.org",
    databaseURL: "https://of-applikation.firebaseio.com",
    projectId: "of-applikation",
    storageBucket: "of-applikation.appspot.com",
    messagingSenderId: "611205171088"
};

// var devConfig = {
//     apiKey: "AIzaSyAJMGYo3FuwVrLFjmjo_D9QkKThDfSpViA",
//     authDomain: "of-applikation-dev.firebaseapp.com",
//     databaseURL: "https://of-applikation-dev.firebaseio.com",
//     projectId: "of-applikation-dev",
//     storageBucket: "of-applikation-dev.appspot.com",
//     messagingSenderId: "68994417535"
// };

// var stageConfig = {
//     apiKey: "AIzaSyBXEhN4aGRg2pz82uaWq5aOq0OA86BdD9o",
//     authDomain: "of-applikation-stage.firebaseapp.com",
//     databaseURL: "https://of-applikation-stage.firebaseio.com",
//     projectId: "of-applikation-stage",
//     storageBucket: "of-applikation-stage.appspot.com",
//     messagingSenderId: "869484024581"
// };

firebase.initializeApp(config);
// firebase.initializeApp(stageConfig);
// firebase.initializeApp(devConfig);

export const provider = {
    google: new firebase.auth.GoogleAuthProvider(),
    facebook: new firebase.auth.FacebookAuthProvider()
};
export const auth = firebase.auth();
export const db = firebase.firestore();
export const appsRef = db.collection("applications");
export const profilesRef = db.collection("profiles");

export default firebase;



// WEBPACK FOOTER //
// ./src/firebase.js